import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {HttpService} from './http.service';
import { RehabImpMarketsMst } from '../../../interfaces/masters/rehab-imp-markets-mst';

@Injectable()
export class RehabImpMarketsMstApi {
    private readonly apiController: string = 'RehabImpMarketsMst';
  
    constructor(private api: HttpService) { }
  
    list(url: string, options?: any): Observable<any[]> {
  
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
  
    getById(url : string, options?: any): Observable<RehabImpMarketsMst> {
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directGet(url,header);
    }
  
    add(url:string, data: RehabImpMarketsMst):Observable<RehabImpMarketsMst[]>{    
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');      
      return this.api.post( url, data, header);
    }
  
    update(url:string, data: RehabImpMarketsMst):Observable<any>{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');      
      return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
  
    delete(url: string):Observable<any>{
      return this.api.directDelete(url);
    }
  }
